import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '../../shared/components/ui/Button/Button'
import { Input } from '../../shared/components/ui/Input/Input'
import { Icon } from '../../shared/components/ui/Icon/Icon'
import { useToast } from '../../shared/context/ToastContext'
import { useApiError } from '../../shared/hooks/useApiError'
import { useBrand } from '../../shared/context/BrandContext'
import authService from '../LoginPage/services/authService'
import './styles.css'

export default function ForgotPasswordPage() {
  const { t } = useTranslation()
  const { brand, getLogo } = useBrand()
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const { showSuccess, showError, showWarning } = useToast()
  
  // Los mensajes por defecto son suficientes
  const { handleError } = useApiError({
    notificationStrategy: {
      showError: showError,
      showWarning: showWarning,
    },
  })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!email) {
      showError('Por favor, introduce tu correo electrónico')
      return
    }

    setIsLoading(true)

    try {
      await authService.forgotPassword(email)
      
      setEmailSent(true)
      showSuccess('Te hemos enviado un correo con las instrucciones para restablecer tu contraseña')
    } catch (error) {
      handleError(error)
    } finally {
      setIsLoading(false)
    }
  }

  if (emailSent) {
    return (
      <div className="forgot-password-page">
        <div className="forgot-password-card">
          <div className="forgot-password-logo-container">
            <img src={getLogo('iso', 'light')} alt={brand.displayName} className="forgot-password-logo" />
          </div>
          <h1>{t('auth.emailSentTitle')}</h1>
          <p className="success-message">
            {t('auth.emailSentMessage', { email })}
          </p>
          <p className="info-message">
            {t('auth.checkSpam')}
          </p>
          <Link to="/login" className="back-link">
            {t('auth.backToLogin')}
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-card">
        <div className="forgot-password-logo-container">
          <img src={getLogo('iso', 'light')} alt={brand.displayName} className="forgot-password-logo" />
        </div>
        <div className="forgot-password-welcome">
          <span className="forgot-password-welcome-text">{t('auth.forgotPasswordTitle')}</span>
        </div>
        <p className="description">
          {t('auth.forgotPasswordDescription')}
        </p>
        
        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="input-group">
            {/* <label className="input-label">{t('auth.emailLabel')}</label> */}
            <div className="input-with-icon">
              <Icon name="mail" size={18} className="input-icon" />
              <Input
                type="email"
                placeholder={t('auth.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </div>
          
          <div className="button-row">
            <Button type="button" onClick={() => window.history.back()} disabled={isLoading}>
              <Icon name="chevron-left" size={18} />
              {t('common.back')}
            </Button>
            <Button type="submit" disabled={isLoading || !email.trim()}>
              {isLoading ? t('common.sending') : t('common.continue')}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
